import { useKontentItems } from "hooks/CMS/useGetItems/useGetItems";
import { useUrlSegments } from "hooks/getUrlSegments/useUrlSegments";
import { generalPagesResolver } from "models/cms/kontent_model/Resolvers/generalPage";
import { useEffect, useState } from "react";
import { compareArrays } from "utils/util";
import { generalPage } from "types/CMS/Unum/GeneralPage/generalPage";
import { PageGeneral } from "types/CMS/KontentAI/content-types/general_page";
import useGetCompanyProductsByUser from "hooks/User/GetProductsByUser/useGetProductsByUser";

export const useFetchGeneralPage = () => {
  const [error, setError] = useState<{
    isError: boolean;
    errorType?: "pageNotFound" | "apiError" | "other";
    errorMessage: string;
  }>({ isError: false, errorMessage: "" });

  const [loading, setLoading] = useState(true);
  const [generalPage, setGeneralPage] = useState<generalPage | undefined>(
    undefined
  );
  const { companyProductsByUser } = useGetCompanyProductsByUser();
  const current = useUrlSegments();

  const { fetchData } = useKontentItems({
    type: "general_page",
    resolver: async (data: PageGeneral[] | PageGeneral) => {
      try {
        return generalPagesResolver(data, {
          usersProducts: await companyProductsByUser(),
        });
      } catch {
        return [];
      }
    },
    depth: 10,
    equals: { key: "elements.url_slug", value: current[current.length - 1] },
  });

  useEffect(() => {
    const asyncCall = async () => {
      setLoading(true);

      const { isError, data } = await fetchData();

      if (isError) {
        setError({
          isError: true,
          errorType: "apiError",
          errorMessage: "API Error",
        });
        setLoading(false);
        return;
      }

      const correctPage = (await data)?.find(
        (page) =>
          page?.page.urlPath && compareArrays(current, page?.page.urlPath)
      );

      if (!correctPage) {
        setError({
          isError: true,
          errorType: "pageNotFound",
          errorMessage: "Page not found",
        });
        setLoading(false);
        return;
      }

      setLoading(false);
      setGeneralPage(correctPage);
    };

    asyncCall();
  }, [current]);

  return { loading, setLoading, error, setError, generalPage, setGeneralPage };
};
